<template>
  <div>

    <b-modal
      v-model="deleteVideoModal"
      content-class="airspirit-modal"
      hide-footer
      header-class="airspirit-modal-header"
      size="md"
    >
      <template #modal-header>
        <div 
          @click="deleteVideoModal = false"
          class="airspirit-modal-header--close-icon"
          style="float: left"
        >
          <img 
            :src="require('@/assets/images/pictos/croix.svg')"
          />
        </div>
        <div
          class="airspirit-modal-header--title"
          style=""
        >
          {{ $t('create_or_modify_video.delete_modal.title') }}
        </div>
  
      </template>
      <p>
        {{ $t('create_or_modify_video.delete_modal.confirm_question') }}
      </p>
      <p>
        {{ $t('create_or_modify_video.delete_modal.confirm_warning') }}
      </p>
      <button
        class="profile-delete-button"
        style="width: 100%;"
        @click="deleteVideo"
      >
        {{ $t('create_or_modify_video.delete_modal.confirm_button') }}
      </button>
    </b-modal>
    
    <div class="video-section mt-4">
      <img
        src="@/assets/images/video/flag_1.svg"
      />
      <p>
        <strong style="text-decoration: underline; text-underline-offset: 10px;"> {{ $t('create_or_modify_video.categories.section_title') }} </strong>
      </p>
    </div>

    <div class="video-categories mt-4">
      <div
        v-for="category in categories"
        :key="category"
        class="video-category"
        @click="toggleCategory(category)"
        :style="categoryStyle(category)"
      >
        <img 
          :src="getCategoryLogoUrl(category)"
          :alt="category"
        > 
        <div class="mt-2" >{{ category }}</div>
      </div>
    </div>

    <p
      v-if="$v.video.categories.$invalid && showErrorMessage"
      class="text-danger"
    >
      {{ $t('create_or_modify_video.categories.error_required') }}
    </p>

    <br>

    <div class="video-section mt-4">
      <img
        src="@/assets/images/video/flag_2.svg"
      />
      <p>
        <strong style="text-decoration: underline; text-underline-offset: 10px;"> {{ $t('create_or_modify_video.content_details.section_title') }} </strong>
      </p>
    </div>

    <select v-model="video.video_access_option" class="registration-input mt-2" :class="{'is-invalid-input': $v.video.video_access_option.$dirty && $v.video.video_access_option.$error}" style="background-color: white;">
      <option :value="null" disabled>{{ $t('create_or_modify_video.content_details.access_option_placeholder') }}</option>
      <option
        v-for="option in videoAccessOptionChoices"
        :key="option['value']"
        :value="option['value']"
      >
        {{ option['label'] }}
      </option> 
    </select>
    <p
      v-if="$v.video.video_access_option.$invalid && showErrorMessage"
      class="text-danger"
    >
      {{ $t('create_or_modify_video.content_details.access_option_error') }}
    </p>

    <input
      class="registration-input modify-video-inputs-input mt-2"
      :class="{'is-invalid-input': $v.video.title.$dirty && $v.video.title.$error}"
      type="text"
      maxlength="200"
      :placeholder="$t('create_or_modify_video.content_details.title_placeholder')"
      v-model="video.title"
      @input="$v.video.title.$touch()"
    />
    <p
      v-if="$v.video.title.$invalid && showErrorMessage"
      class="text-danger"
    >
      {{ $t('create_or_modify_video.content_details.title_error') }}
    </p>

    <textarea
      class="registration-input modify-video-inputs-input mt-2"
      :class="{'is-invalid-input': $v.video.description.$dirty && $v.video.description.$error}"
      :placeholder="$t('create_or_modify_video.content_details.description_placeholder')"
      v-model="video.description"
      @input="$v.video.description.$touch()"
      style="height: 200px;"
    />
    <p
      v-if="$v.video.description.$invalid && showErrorMessage"
      class="text-danger"
    >
      {{ $t('create_or_modify_video.content_details.description_error') }}
    </p>

    <select v-model="video.language" class="registration-input registration-input--select mt-2" name="currency">
      <option
        v-for="languageOption in languageOptions"
        :key="languageOption['value']"
        :value="languageOption['value']"
      >
        {{ languageOption['label'] }}
      </option>
    </select>

    <input
      v-if="video.video_access_option === 'PAY_PER_VIEW'"
      class="registration-input modify-video-inputs-input mt-2"
      :class="{'is-invalid-input': $v.video.price.$dirty && $v.video.price.$error}"
      type="number"
      :placeholder="$t('create_or_modify_video.content_details.price_placeholder')"
      v-model="video.price"
      @input="$v.video.price.$touch()"
    />
    <p
      v-if="$v.video.price.$invalid && showErrorMessage && video.video_access_option === 'PAY_PER_VIEW'"
      class="text-danger"
    >
      {{ $t('create_or_modify_video.content_details.price_error') }}
    </p>

    <div v-if="create">
      <div
        v-if="video.image_cover"     
        class="picture-upload" style="width: 100%;">
        <figure class="picture-upload__img">
          <img 
            :src="displayImageWithObjectUrl(video.image_cover)" 
            class="picture-img-cover"  
            :alt="$t('create_or_modify_video.cover_image.image_upload_alt')"
          >
          <button class="video-picture-delete-button" @click="deletePictureFromVideo">&times;</button>
        </figure>
      </div>
      
      <div 
        v-else
        class="add-picture"
      >
        <label for="input-upload"></label>
        <img 
          :src="require('@/assets/images/pictos/picto_photos.png')"
          :alt="$t('create_or_modify_video.cover_image.photos_alt')"
          class="add-picture-icon"
        />
        <p>
          <strong>{{ $t('create_or_modify_video.cover_image.choose_cover_image') }}</strong>
        </p>
        <p>
          <small>
            <u>{{ $t('create_or_modify_video.cover_image.upload_from_device') }}</u>
          </small>
        </p>
      
        <input 
          type="file" 
          id="input-upload" 
          required="required" 
          class="add-picture-input"
          accept="image/*"
          @change="addPictureToVideo"
        >
      </div>
    </div>


    <div v-else class="mt-4">
      <div
        v-if="video.image_cover" 
        class="picture-upload">
        <figure class="picture-upload__img">
          <img 
            :src="displayImageWithObjectUrl(video.image_cover)"
            class="picture-img-cover"  
            :alt="$t('create_or_modify_video.cover_image.image_upload_alt')"
          >
          <button class="video-picture-delete-button" @click="deletePictureFromVideo">&times;</button>
        </figure>
      </div>
      <div
        v-else 
        class="add-picture"
      >
        <label for="input-upload"></label>
        <img 
          :src="require('@/assets/images/pictos/picto_photos.png')"
          :alt="$t('create_or_modify_video.cover_image.photos_alt')"
          class="add-picture-icon"
        />
        <p>
          <strong>{{ $t('create_or_modify_video.cover_image.choose_cover_image') }}</strong>
        </p>
        <p>
          <small>
            <u>{{ $t('create_or_modify_video.cover_image.upload_from_device') }}</u>
          </small>
        </p>
        <input 
          type="file" 
          id="input-upload" 
          required="required" 
          class="add-picture-input"
          accept="image/*"
          @change="addPictureToVideo"
        >
      </div>
    </div>

    <br>

    <div class="video-section mt-4">
      <img
        src="@/assets/images/video/flag_3.svg"
      />
      <p>
        <strong style="text-decoration: underline; text-underline-offset: 10px;"> {{ $t('create_or_modify_video.upload_video.section_title') }} </strong>
      </p>
    </div>

    <div 
      v-if="create"
      class="row mt-2"
    >
      <div class="col-12">
        <div class="add-video-file">
          <label for="input-upload"></label>
          <p>
            <strong>{{ $t('create_or_modify_video.upload_video.upload_prompt') }}</strong>
          </p>
          <input 
            type="file" 
            accept=".mp4, .avi, .mov"
            id="input-upload" 
            required="required" 
            class="add-video-file-input"
            @change="onVideoFileChange"
          >
        </div>

        <div
          v-if="video.file"
          class="video-section mt-4"
        >
          <strong>
            {{ $t('create_or_modify_video.upload_video.video_uploaded_label') }}
          </strong>
          {{ video.file.name }}
        </div>
        <p
          v-if="$v.video.file.$invalid && showErrorMessage"
          class="text-danger mt-2"
        >
          {{ $t('create_or_modify_video.upload_video.file_error') }}
        </p>
      </div>
    </div>

    <div class="profile-footer">
      <div 
        @click='$router.go(-1)'
        class="profile-back-pc-button"
      >
        <img
          src="@/assets/images/button/back/back_pc.svg"
          :alt="$t('create_or_modify_video.footer.back_alt')"
        />
      </div>
      <div v-if="create">
        <button
          class="profile-validation-button mr-2"
          @click="createOrModifyVideo('DRAFT')"
        >
          {{ $t('create_or_modify_video.footer.save_button') }}
        </button>
        <button
          class="profile-validation-button"
          @click="createOrModifyVideo('VALIDATED')"
        >
          {{ $t('create_or_modify_video.footer.save_publish_button') }}
        </button>
      </div>
      <div v-else>
        <button
          class="profile-delete-button mr-2"
          @click="deleteVideoModal = true"
        >
          {{ $t('create_or_modify_video.footer.delete_content_button') }}
        </button>
        <button
          class="profile-validation-button"
          @click="createOrModifyVideo('VALIDATED')"
        >
          {{ $t('create_or_modify_video.footer.update_content_button') }}
        </button>
      </div>
    </div>
  </div>
      
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, requiredIf, numeric } from 'vuelidate/lib/validators'

import { videoMxins } from '@/mixins/videoMixins'
import {documentValidator, documentSizeValidator} from '@/validators/validators'
import { slugifyAssetName } from '@/utils/slugify'

export default {
  name: 'CreateOrModifyAd',
  props: {
    categories : {
      type: Array,
      default: () => []
    },
    create: {
      type: Boolean,
      default: false
    },
    originalVideo: {
      type: Object,
      default: null,
    }
  },
  mixins: [validationMixin, videoMxins],
  data: function () {
    return {
      video: {
        categories: [],
        language: 'EN',
        image_cover: null,
        title: '',
        description: '',
        file: null,
        price: null,
        video_access_option: null,
        status: "DRAFT"
      },
      deleteVideoModal: false,
      showErrorMessage: false
    }
  },
  watch: {
    originalVideo: function(value) {
      this.video = value
    },
  },
  mounted () {
    if (this.originalVideo) {
      this.video = this.originalVideo
    }
  },
  validations: {
    video: {
      categories: {
        required
      },
      title: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(200)
      },
      description: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(1000)
      },
      language: {
        required
      },
      video_access_option: {
        required
      },
      file: {
        required: requiredIf(function() {
          return this.create
        })
      },
      price: {
        required: requiredIf(function() {
          return this.video.video_access_option === 'PAY_PER_VIEW'
        }),
        numeric
      }
    }
  },
  methods: {
    addPictureToVideo (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length)
        return null
      const file = files[0]
      if (!documentValidator(file) || !documentSizeValidator(file)) {
        this.$root.$bvToast.toast(this.$t('create_or_modify_video.toasts.incorrect_photo_message'), {
          title: this.$t('create_or_modify_video.toasts.incorrect_photo_title'),
          autoHideDelay: 5000,
          appendToast: false,
          variant: "danger"
        })
        return null
      } 
      this.video.image_cover = files[0]
    },
    categoryStyle(category) {
      return this.video.categories.includes(category) ? `border-bottom: solid 2px black; padding-bottom: 5px;` : ''
    },
    createOrModifyVideo(statusValue) {
      this.$v.$touch()
      this.showErrorMessage = false
      if (this.$v.video.$invalid) {
        this.showErrorMessage = true
        return
      }
      else {
        this.video.status = statusValue
        this.$emit('create-or-modify-video', this.video)
      }
      
    },
    deletePictureFromVideo () {
      this.video.image_cover = null
    },
    displayImageWithObjectUrl(file) {
      if (typeof file === 'string') {
        return file
      }
      return URL.createObjectURL(file)
    },
    deleteVideo() {
      this.$emit('delete-video', this.video)
    },
    getCategoryLogoUrl(category) {
      return require('@/assets/images/video/logo_' + slugifyAssetName(category) + '.svg')
    },
    toggleCategory(category) {
      if (this.video.categories.includes(category)) {
        this.video.categories = this.video.categories.filter(c => c !== category)
      } else {
        this.video.categories.push(category)
      }
    },
    onImageCoverChange(event) {
      const file = event.target.files[0]
      if (file) {
        this.video.image_cover = file
      }
    },
    onVideoFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        this.video.file = file
      }
    },
  }
}
</script>

<style>

.video-categories {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 15px;
}

@media screen and (min-width: 768px) {
  .video-categories {
    padding-left: 50px;
    padding-right: 50px;
  }
}
  
.video-category {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 10px;
  text-align: center;
  flex: 1 0 21%; /* explanation below */
}

@media screen and (min-width: 768px) {
  .video-category {
    flex: unset;
  }
}

.video-category > img {
  height: 35px;
}

.video-section {
  display: flex;
  gap: 10px;
}

.video-section > img {
  height: 20px;
  margin-top: 5px;
}
.modify-video-inputs {
  display: flex;
  flex-wrap: wrap;

  gap: 10px;
}

.modify-video-inputs-input {
  display: flex;
  flex-direction: column;
}

.add-video-file {
  display: flex;
  position: relative;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: distribute;
  justify-content: center;
  width: 100%; 
  transition: box-shadow .2s ease-in-out;
  border-radius: 6px;
  border: 1px dashed #ccc;
  text-align: center;
  cursor: pointer;
  height: 200px;
}


.add-video-file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}


.add-picture {
  display: inline-flex;
  position: relative;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  width: 100%; 
  transition: box-shadow .2s ease-in-out;
  border-radius: 6px;
  border: 1px dashed #ccc;
  text-align: center;
  cursor: pointer;
}

.add-picture-icon {
  width: 100px;
  height: 100px;
}

.add-picture-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.video-picture-delete-button {
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  margin-top: 10px;
  margin-left: 10px;
  background-color: rgba(0,0,0,0.4);
  border: none;
  border-radius: 50%;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

</style>
